import _ from 'lodash';
import utils from 'lib/utils';
import qs from 'query-string';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchList = async (params = {}) => {
  try {
    // let bodyParams = reqTransform.fetchList(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/Report/GetInbuiltReport`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    let resData = await utils.processApiRes(res);

    return resTransform.fetchList(resData);
  } catch (err) {
    console.log('api-generateReport-fetchList->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'GetInbuiltReport');
    throw errors;
  }
};

export const getReportData = async (params = {}, keyBy) => {
  try {
    let bodyParams = reqTransform.fetchList(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/Report/GetInbuiltReport`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;
    let resData = await utils.processApiRes(res);

    return resData;
  } catch (err) {
    console.log('api-generateReport-fetchList->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'GetInbuiltReport');
    throw errors;
  }
};

export const fetchReportList = async (params = {}) => {
  try {
    let bodyParams = reqTransform.fetchList(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/Report/GetInbuiltReport`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;
    let resData = await utils.processApiRes(res);
    return resTransform.fetchReportList(resData);
  } catch (err) {
    console.log('api-generateReport-fetchList->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'GetInbuiltReport');
    throw errors;
  }
};
export const fetchDetails = async (id) => {
  try {
    const params = reqTransform.fetchDetails(id);
    let list = await fetchList({});
    const resData = list['id'];
    return resTransform.fetchDetails(resData);
  } catch (err) {
    console.log('api-transport-fetchDetails->err---->', err);
    throw err;
  }
};

export const create = async (params) => {
  try {
    let bodyParams = reqTransform.create(params);

    const url = `${baseUrl}/BioFuelPayments/api/Payment/SaveUpdatePaymentAllocationAgainstInvoiceIds`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify([bodyParams]),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.create(resData);
  } catch (err) {
    console.log('SaveAndUpdateAffiliateDetails-create->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SaveUpdatePaymentAllocationAgainstInvoiceIds');
    throw errors;
  }
};

export const update = async (id, params = {}) => {
  try {
    let bodyParams = reqTransform.update(id, params);

    const url = `${baseUrl}/BioFuelPayments/api/Payment/SaveUpdatePaymentAllocationAgainstInvoiceIds`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify([bodyParams]),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.update(resData);
  } catch (err) {
    console.log('SaveAndUpdateAffiliateDetails-update->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'SaveUpdatePaymentAllocationAgainstInvoiceIds');
    throw errors;
  }
};

export const destroy = async (id) => {
  try {
    const qs = reqTransform.destroy(id);
    const url = `${baseUrl}/BioFuelRegistration/api/BusinessProfile/DeleteAffiliateAgainstComapnyAffiliateId?company_affiliate_id=${qs}`;
    // const res = await utils.fetch(url).ready;
    const res = await utils.fetch(url, {
      method: 'PUT',
    }).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.destroy(resData);
  } catch (err) {
    console.log('api-transport-update->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'DeleteAffiliateAgainstComapnyAffiliateId');
    throw errors;
  }
};

export const fetchSupplierProfilesListReport = async (params, isControlTowerUser) => {
  try {
    let bodyParams = reqTransform.fetchSupplierProfilesListReport(params);
    let url = '';
    if (isControlTowerUser) {
      url = `${baseUrl}/BioFuelRegistration/api/ExtendedProfile/FetchAllExtendedProfileApplications`;
    } else {
      url = `${baseUrl}/BioFuelRegistration/api/ExtendedProfile/FetchExtendedProfileHistory`;
    }

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchSupplierProfilesListReport(resData);
  } catch (err) {
    console.log('SaveAndUpdateKYC_BusinessUser-create->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchAllExtendedProfileApplications');
    throw errors;
  }
};

export const platformChargesReportData = async (params = {}) => {
  try {
    let bodyParams = reqTransform.platformChargesReportData(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/Report/GetInbuiltReport`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;
    let resData = await utils.processApiRes(res);
    resData = resData.map((item) => ({ ...item, id: item.prepaid_passbook_id }));
    return resData;
  } catch (err) {
    console.log('api-generateReport-platformChargesReportData->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'GetInbuiltReport');
    throw errors;
  }
};

export const getEmissionsSustainabilityReport = async (params = {}) => {
  try {
    let bodyParams = reqTransform.getEmissionsSustainabilityReport(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/Report/getEmissionsSustainabilityReport`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;
    let resData = await utils.processApiRes(res);
    // resData = resData.map((item) => ({ ...item, id: item.delivery_id }));
    // return resData;
    return resTransform.getEmissionsSustainabilityReport(resData);
  } catch (err) {
    console.log('api-getEmissionsSustainabilityReport->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'getEmissionsSustainabilityReport');
    throw errors;
  }
};
